(function fixAuLinks() {
  if (!(window.Shopify && Shopify.country === 'AU')) return;

  const DOMAIN_MAP = [
    { nz: 'https://www.utemaster.co.nz/', au: 'https://www.utemaster.com.au/' },
    { nz: 'https://utemaster.co.nz/', au: 'https://utemaster.com.au/' },
  ];

  function fixLink(link) {
    for (const { nz, au } of DOMAIN_MAP) {
      if (link.href.startsWith(nz)) {
        link.href = au + link.href.slice(nz.length);
        return;
      }
    }
  }

  function fixLinksIn(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches?.('a[href]')) fixLink(root);
    root.querySelectorAll?.('a[href]').forEach(fixLink);
  }

  fixLinksIn(document.body);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) fixLinksIn(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
